<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <form>
        <vx-card>
          <vs-row vs-w="12" class="mb-5">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="1"
              vs-sm="4"
              vs-xs="12"
            >
              <vs-button
                @click="goBack"
                color="danger"
                type="border"
                icon="keyboard_backspace"
                >Back</vs-button
              >
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="9"
              vs-sm="4"
              vs-xs="12"
            >
              <h3>Add a New Role</h3>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
            </vs-col>
          </vs-row>
          <vs-divider class="m-5" />
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Role:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="role"
                v-model="roles.role"
                v-validate="'required'"
                data-vv-as="Role"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('role')"
              >{{ errors.first("role") }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Role Description:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-input
                class="w-full"
                name="role_description"
                v-model="roles.role_description"
                v-validate="'required'"
                data-vv-as="Role Description"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('role_description')"
              >{{ errors.first("role_description") }}</span
            >
          </div>
                    <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Is Client Role:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-checkbox name="is_client_role" data-vv-as="Client Role" v-model="roles.is_client_role"></vs-checkbox>
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('is_client_role')"
              >{{ errors.first("is_client_role") }}</span
            >
          </div>
          <vs-divider class="m-5" />
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full"></div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-button class="mr-3 mb-2" @click.prevent="submitForm"
                >Submit</vs-button
              >
            </div>
          </div>
        </vx-card>
      </form>
    </div>
  </div>
</template>
<script>
// Store Module
import defineAbilitiesFor from '@/config/abilities'
import moduleRoleManagement from "@/store/role-management/moduleRoleManagement.js";
import RoleAutocomplete from "@/components/autocomplete/RoleAutocomplete.vue";
import vSelect from "vue-select";
export default {
  data() {
    return {
                              abilities : null,

      roles : {
        is_client_role:null,
              role:null,
              role_description : null
              }
      }
      
  },
  components: {
    "v-select": vSelect,
    moduleRoleManagement,
    RoleAutocomplete
  },
  created() {
        var self = this
    defineAbilitiesFor().then(function(data){
      self.abilities = data
    });  
    if (!moduleRoleManagement.isRegistered) {
      this.$store.registerModule(
        "rolesManagement",
        moduleRoleManagement
      );
      moduleRoleManagement.isRegistered = true;
    }
  },
  mounted() {
  },
  methods: {
    goBack: function() {
      this.$router.go(-1);
    },
    submitForm() {
      let self = this
      self.$validator.validateAll().then(result => {

        if (self.roles.is_client_role) {
          self.roles.is_client_role = 'y'
        } else {
          self.roles.is_client_role = 'n'
        }

        if(result){
          this.addRoles()
        }
      });
    },
    addRoles() {
      this.$store
        .dispatch("rolesManagement/addRole",this.roles)
        .then(res => {
          if (res.data.status == "fail") {
            this.$vs.notify({
              color: "danger",
              title: "Role Exists",
              text: res.data.message
            });
          } else {
            this.$vs.notify({
              color: "success",
              title: "Role Added",
              text: "The role was added successfully"
            });
            this.$router.push({ path: "/roles" });
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    }
  }
};
</script>
<style scoped>
.removeButton {
  cursor: pointer;
}
</style>
